/**
 * Academic Database Manifest for solveicse.dev
 * Tracked assets, pending downloads, and validated external resources.
 */

const academicResourceManifest = {
  "metadata": {
    "lastUpdated": "2026-06-14",
    "totalClasses": 4,
    "sourceManifest": {
      "official": "https://www.cisce.org/",
      "aglasem": "https://schools.aglasem.com/cisce-question-papers/",
      "educart": "https://www.educart.co/previous-year-question-paper/icse-question-papers-class-10",
      "jagranJoshICSE": "https://www.jagranjosh.com/articles/icse-class-10-previous-year-question-papers-pdf-1675255835-1",
      "jagranJoshISC": "https://www.jagranjosh.com/articles/isc-class-12-previous-year-question-papers-pdf-1675327233-1",
      "oswaalICSE": "https://www.oswaal360.com/pages/icse-class-10-previous-year-question-papers-2024-with-solution--free-pdf-download",
      "oswaalISC": "https://www.oswaal360.com/pages/isc-class-12-previous-year-question-papers-with-solution-free-pdf-download",
      "shaalaaICSE": "https://www.shaalaa.com/search-textbook-solutions/cisce-icse-class-10-indian-certificate-of-secondary-education_661",
      "shaalaaISC": "https://www.shaalaa.com/search-question-papers/cisce-class-12-isc-science_1432"
    }
  },
  "resources": {
    "ICSE-Class-10": {
      "Mathematics": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Mathematics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Physics": [
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Physics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Chemistry": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Chemistry_PastPaper.pdf",
          "status": "available"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Biology": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Biology_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Commercial Studies": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_CommercialStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_CommercialStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_CommercialStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_CommercialStudies_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Computer Applications": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_ComputerApplications_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_ComputerApplications_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_ComputerApplications_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Economics": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Economics_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "History & Civics": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_HistoryCivics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_HistoryCivics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_HistoryCivics_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Geography": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Geography_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Geography_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Geography_PastPaper.pdf",
          "status": "pending_download"
        }
      ]
    },
    "ICSE-Class-9": {
      "Mathematics": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Mathematics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Physics": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Physics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Chemistry": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Biology": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Biology_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Computer Applications": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_ComputerApplications_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_ComputerApplications_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_ComputerApplications_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "History & Civics": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_HistoryCivics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_HistoryCivics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_HistoryCivics_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Geography": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Geography_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Geography_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Geography_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "English Language & Literature": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_English_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_English_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_English_PastPaper.pdf",
          "status": "pending_download"
        }
      ]
    },
    "ISC-Class-11": {
      "Mathematics": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Mathematics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Physics": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Physics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Chemistry": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Biology": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Biology_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Commerce": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Commerce_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Commerce_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Commerce_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Commerce_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Economics": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Economics_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Accountancy": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Business Studies": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        }
      ]
    },
    "ISC-Class-12": {
      "Mathematics": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Mathematics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Physics": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Physics_PastPaper.pdf",
          "status": "available"
        }
      ],
      "Chemistry": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Chemistry_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Biology": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Biology_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Biology_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Commerce": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Commerce_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Commerce_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Commerce_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Commerce_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Economics": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Economics_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Economics_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Accountancy": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_Accountancy_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Business Studies": [
        {
          "year": 2025,
          "type": "PastPaper",
          "filename": "2025_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_BusinessStudies_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "Computer Science": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_ComputerScience_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_ComputerScience_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_ComputerScience_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "English Language": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_EnglishLanguage_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_EnglishLanguage_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_EnglishLanguage_PastPaper.pdf",
          "status": "pending_download"
        }
      ],
      "English Literature": [
        {
          "year": 2024,
          "type": "PastPaper",
          "filename": "2024_EnglishLiterature_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2023,
          "type": "PastPaper",
          "filename": "2023_EnglishLiterature_PastPaper.pdf",
          "status": "pending_download"
        },
        {
          "year": 2022,
          "type": "PastPaper",
          "filename": "2022_EnglishLiterature_PastPaper.pdf",
          "status": "pending_download"
        }
      ]
    }
  }
};

// Helper functions for resource management
academicResourceManifest.getAvailableResources = function(className, subject = null) {
  if (!this.resources[className]) return [];
  if (subject) {
    return this.resources[className][subject]?.filter(r => r.status === 'available') || [];
  }
  return Object.values(this.resources[className]).flat().filter(r => r.status === 'available');
};

academicResourceManifest.getPendingDownloads = function(className = null) {
  if (className) {
    if (!this.resources[className]) return [];
    return Object.values(this.resources[className]).flat().filter(r => r.status === 'pending_download');
  }
  return Object.values(this.resources).flat().flat().filter(r => r.status === 'pending_download');
};

academicResourceManifest.markResourceAsDownloaded = function(className, subject, filename) {
  if (!this.resources[className] || !this.resources[className][subject]) return false;
  const resource = this.resources[className][subject].find(r => r.filename === filename);
  if (resource) {
    resource.status = 'available';
    this.metadata.lastUpdated = new Date().toISOString().split('T')[0];
    return true;
  }
  return false;
};

academicResourceManifest.getTotalStats = function() {
  let total = 0;
  let available = 0;
  let pending = 0;
  
  Object.values(this.resources).forEach(classData => {
    Object.values(classData).forEach(subjectData => {
      subjectData.forEach(resource => {
        total++;
        if (resource.status === 'available') available++;
        if (resource.status === 'pending_download') pending++;
      });
    });
  });
  
  return { total, available, pending };
};

export default academicResourceManifest;
